import * as z from "zod";
import type { TFunction } from "i18next";

export const createLicenseSchema = (t: TFunction) =>
  z.object({
    structureId: z
      .string()
      .min(1, t("management.licenses.validation.structureRequired")),
    moduleId: z
      .string()
      .min(1, t("management.licenses.validation.moduleRequired")),
    quantity: z.coerce
      .number({
        invalid_type_error: t(
          "management.licenses.validation.licensesInvalid",
        ),
      })
      .int(t("management.licenses.validation.licensesInvalid"))
      .min(1, t("management.licenses.validation.licensesRequired")),
    startDate: z.date({
      required_error: t("management.licenses.validation.startDateRequired"),
    }),
    endDate: z.date({
      required_error: t("management.licenses.validation.endDateRequired"),
    }),
    managementEmail: z
      .string()
      .min(1, t("management.licenses.validation.managerEmailRequired"))
      .email(t("management.licenses.validation.emailInvalid")),
    clientEmail: z
      .string()
      .min(1, t("management.licenses.validation.clientEmailRequired"))
      .email(t("management.licenses.validation.emailInvalid")),
    notificationDays: z
      .array(z.number())
      .min(1, t("management.licenses.validation.notificationPeriodsMin")),
  });

export type LicenseFormData = z.infer<ReturnType<typeof createLicenseSchema>>;

export const updateLicenseSchema = (t: TFunction) =>
  z.object({
    managementEmail: z
      .string()
      .min(1, t("management.licenses.validation.managerEmailRequired"))
      .email(t("management.licenses.validation.emailInvalid")),
    clientEmail: z
      .string()
      .min(1, t("management.licenses.validation.clientEmailRequired"))
      .email(t("management.licenses.validation.emailInvalid")),
  });

export type UpdateLicenseFormData = z.infer<
  ReturnType<typeof updateLicenseSchema>
>;
